/* Fine Foams header behaviour: Shop mega panel + mobile full-screen menu. */
(function () {
  var header = document.getElementById('ff-header');
  if (!header) return;

  var megaToggle = header.querySelector('[data-ff-mega-toggle]');
  var mega = document.getElementById('ff-mega');
  var scrim = header.querySelector('[data-ff-scrim]');
  var burger = header.querySelector('[data-ff-burger]');
  var mobileMenu = document.getElementById('ff-mobile-menu');
  var caret = header.querySelector('.ff-header__caret');

  function setMega(open) {
    if (!mega) return;
    mega.hidden = !open;
    if (scrim) scrim.hidden = !open;
    if (megaToggle) megaToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (caret) caret.innerHTML = open ? '&#9652;' : '&#9662;';
  }

  function lockScroll(lock) {
    // BODY ONLY. overflow:hidden on <html> breaks position:sticky, which
    // teleports the sticky header off-screen the instant the menu opens —
    // that was the original blank-menu bug. A body-only lock keeps the
    // header pinned (verified) while still stopping background scroll.
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  // The panel slides in from the left BELOW the sticky header, so the header
  // (and its burger-turned-X) stays visible wherever the menu is opened.
  // Its top is computed once per open; the body is locked while open, so the
  // header cannot move underneath it. No scroll listeners.
  function positionMobileMenu() {
    mobileMenu.style.top = Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px';
  }

  function setMobile(open) {
    if (!mobileMenu) return;
    if (open) {
      setMega(false);
      positionMobileMenu();
    }
    mobileMenu.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    lockScroll(open);
  }

  if (megaToggle && mega) {
    megaToggle.addEventListener('click', function () {
      setMega(mega.hidden);
    });
    megaToggle.addEventListener('mouseenter', function () {
      if (window.matchMedia('(hover: hover)').matches) setMega(true);
    });
    header.addEventListener('mouseleave', function () {
      setMega(false);
    });
    header.querySelectorAll('.ff-header__nav a').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        setMega(false);
      });
    });
    mega.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        setMega(false);
      });
    });
  }

  if (scrim) {
    scrim.addEventListener('click', function () {
      setMega(false);
    });
  }

  if (burger && mobileMenu) {
    // The server renders the panel with [hidden] so it cannot flash before this
    // script runs. Once the CSS closed-state (off-canvas + visibility:hidden)
    // is active, the attribute is dropped so open/close can animate.
    mobileMenu.removeAttribute('hidden');
    burger.addEventListener('click', function () {
      setMobile(!mobileMenu.classList.contains('is-open'));
    });
    window.addEventListener('resize', function () {
      if (mobileMenu.classList.contains('is-open')) positionMobileMenu();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setMega(false);
    if (mobileMenu && mobileMenu.classList.contains('is-open')) setMobile(false);
  });
})();
